import React, {useEffect, useRef, useState} from 'react';
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    InputAdornment,
    MenuItem,
    Select,
    Stack,
    TextField,
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import TextFieldWithSetValue from "../../../textfield/TextFieldWithSetValue";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import {CUT_OFF_QUICK_COMMENTS} from "../../../../../data/CutOffQuickComments";

const ModalUpdateCutOff = ({
                               open,
                               handleClose,
                               title,
                               values,
                               setValues,
                               handleSubmit,
                               materialPriceUnit,
                               setMaterialPriceUnit,
                               unableCheckbox
                           }) => {
    const commentFieldRef = useRef(null);
    const [quickCommentsOpen, setQuickCommentsOpen] = useState(false);

    useEffect(() => {
        if (!open) {
            setQuickCommentsOpen(false);
        }
    }, [open]);

    //const edit_MWCO = checkRoleOne(token, 'ROLE_edit_MWCO');
    const edit_MWCO = true;

    const handleQuickCommentSelect = (comment) => {
        setValues({...values, note: comment});
        setQuickCommentsOpen(false);
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: {xs: '300px', sm: '360px', md: '400px'},
                            gap: '0.01rem',
                        }}
                    >
                        <Box ref={commentFieldRef} sx={{position: 'relative'}}>
                            <TextField
                                autoComplete="off"
                                size="small"
                                sx={{
                                    width: '100%',
                                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                    gap: '0.01rem',
                                }}
                                margin="normal"
                                label="Коментарий"
                                name="note"
                                value={values?.note ?? ""}
                                onChange={(e) => setValues({...values, note: e.target.value})}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <ArrowDropDownIcon
                                                fontSize="small"
                                                sx={{cursor: 'pointer', color: 'action.active'}}
                                                onMouseDown={(event) => {
                                                    event.preventDefault();
                                                    setQuickCommentsOpen(true);
                                                }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <Select
                                open={quickCommentsOpen}
                                onClose={() => setQuickCommentsOpen(false)}
                                value=""
                                displayEmpty
                                IconComponent={() => null}
                                onChange={(event) => handleQuickCommentSelect(event.target.value)}
                                MenuProps={{
                                    anchorEl: commentFieldRef.current,
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    },
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 300,
                                            width: commentFieldRef.current?.offsetWidth,
                                        },
                                    },
                                }}
                                sx={{
                                    position: 'absolute',
                                    right: 0,
                                    bottom: 0,
                                    width: 0,
                                    height: 0,
                                    opacity: 0,
                                    pointerEvents: 'none',
                                }}
                            >
                                {CUT_OFF_QUICK_COMMENTS.map((comment) => (
                                    <MenuItem key={comment} value={comment}>
                                        {comment}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>
                        {edit_MWCO && !unableCheckbox &&
                            <TextFieldWithSetValue
                                label="Ширина"
                                values={materialPriceUnit}
                                setValues={setMaterialPriceUnit}
                                field={'length'}
                            />
                        }
                        {edit_MWCO && !unableCheckbox &&
                            <TextFieldWithSetValue
                                label="Высота"
                                values={materialPriceUnit}
                                setValues={setMaterialPriceUnit}
                                field={'width'}
                            />
                        }
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Выйти"} onClick={handleClose}/>
                <ButtonAdd text={"Обновить"} onClick={handleSubmit}/>
            </DialogActions>
        </Dialog>
    );
};

export default ModalUpdateCutOff;
